import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment/environment';
import { Shape, ShapeCreateUpdate } from '@app/pipelines/models/shape';
import { PipelineReportsFilter } from '@app/pipelines/models/pipeline-reports-filter';
import { SurveyPipesheetData } from '@app/pipelines/models/pipeline-reports-pipesheet-chart-data';

@Injectable({
  providedIn: 'root'
})
export class ShapesService {
  readonly url = environment.api + 'pipesheetShapes';
  readonly elementUrl = environment.api + 'elements';
  readonly shapeEventUrl = environment.api + 'pipelinePipesheetReportFilter';
  readonly pipelineUrl = environment.api + 'pipeline';

  constructor(private http: HttpClient) {}

  getAll(): Observable<Shape[]> {
    const requestUrl = `${this.url}`;
    return this.http.get<Shape[]>(requestUrl);
  }

  getPipelinePipesheetShapesByPipelineId(pipelineId: number): Observable<Shape[]> {
    const requestUrl = `${this.pipelineUrl}/${pipelineId}/pipesheetShapes`;
    return this.http.get<Shape[]>(requestUrl);
  }

  getById(shapeId: number): Observable<Shape> {
    const requestUrl = `${this.url}/${shapeId}`;
    return this.http.get<Shape>(requestUrl);
  }

  post(data: ShapeCreateUpdate): Observable<Shape> {
    return this.http.post<Shape>(this.url, data);
  }

  update(data: ShapeCreateUpdate, shapeId: number): Observable<Shape> {
    const requestUrl = `${this.url}/${shapeId}`;
    return this.http.put<Shape>(requestUrl, data);
  }

  delete(id: number): Observable<Shape> {
    const requestUrl = `${this.url}/${id}`;
    return this.http.delete<Shape>(requestUrl);
  }

  getPipelinePipesheetEventData(filterData: PipelineReportsFilter): Observable<SurveyPipesheetData[]> {
    const requestUrl = `${this.shapeEventUrl}`;
    return this.http.post<SurveyPipesheetData[]>(requestUrl, filterData);
  }
}
